export interface ItemCardStyle {
  cornerRadius?: number | null;
  borderWidth?: number | null;
}

export function buildItemCardCssRules(
  s: string,
  style: ItemCardStyle | null | undefined,
): string[] {
  if (!style) return [];

  const itemCardProps: string[] = [];
  if (typeof style.cornerRadius === "number") {
    itemCardProps.push(`border-radius: ${style.cornerRadius}px;`);
  }
  if (typeof style.borderWidth === "number") {
    itemCardProps.push(`border-width: ${style.borderWidth}px;`);
  }

  if (itemCardProps.length === 0) return [];

  const itemCardRule = `${s}[data-ui="item-card"], ${s}[data-ui="address"] { ${itemCardProps.join(" ")} }`;

  const radiusOnlyRule =
    typeof style.cornerRadius === "number"
      ? `${s}[data-ui="login-card"], ${s}[data-ui="summary"], ${s}[data-ui="redo-card"] { border-radius: ${style.cornerRadius}px; }`
      : undefined;

  // Generic bordered radio options keep all selection-card props on the same
  // element, so override them directly.
  const optionProps = itemCardProps.map((p) => p.replace(/;$/, " !important;"));
  const optionRule = `${s}[data-ui="option"] { ${optionProps.join(" ")} }`;

  // Checkbox-card-based option surfaces put the border on an outer wrapper, so
  // override radius/border-width there directly to match the radio options.
  const checkboxCardOuterRule = `${s}[data-selection-card] { ${optionProps.join(" ")} }`;

  return [
    itemCardRule,
    radiusOnlyRule,
    optionRule,
    checkboxCardOuterRule,
  ].filter((rule): rule is string => rule !== undefined);
}
